import classes from "./Slideshow.module.css";
import {Fragment, useEffect, useState} from "react";
import logo from "../../store/logo.png"
import axios from "axios";
import {path} from "../../routes";

const Slideshow = (props) =>{
    const [loadedSlides, setLoadedSlides] = useState(props.slideshow)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [roomsABCD, setroomsABCD] = useState(props.slideshowAD);
    const [roomsEF, setroomsEF] = useState(props.slideshowEF);

    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % loadedSlides.length);
        }, 15000);
console.log(loadedSlides)

        const resetVal = async () => {
            const rs = await axios.post(`${path}/updateReset/78`)
        }
        const getReset = async () =>{
            try {
                const response = await axios.get(`${path}/getReset/78`);
                //console.log(response.data[0].needUpdate);
                if (response.data[0].needUpdate === 1)
                {
                    console.log("update")
                    resetVal()
                    window.location.reload();
                }
                else {
                    console.log("no update")
                }
            }
            catch (error){

            }
        }

        const send = async () => {
            try {
                const response = await axios.get(`${path}/getDayListV2?orgID=7A67452A-F5D4-430D-B283-8A93B28B425C&&day=${getTime()}`);
                if (response.data.length > 0) {
                    props.jump(70)
                } else {

                }

            } catch (error) {

            }
        }
        const intervalId2 = setInterval(send, 60 *  1000);
        const intervalId3 = setInterval(getReset, 60 * 1000);

        return () => {
            clearInterval(intervalId);
            clearInterval(intervalId);
            clearInterval(intervalId2);
        };
    }, []);


    let SlideShow_Bistro =(<div className={classes.slide}>
            <img
                src={loadedSlides[currentIndex]}
                alt={`Slide ${currentIndex + 1}`}
                className={`${classes.slideImage} ${classes.slideEl}`}
            />
          </div>)

    let SlideShow_Totem =(<div className={classes.slideTot}>
        test
    </div>)


    return (<Fragment>
        {SlideShow_Bistro}
    </Fragment>)
}

export default Slideshow